import React, {useEffect, useRef, useState} from "react"
import { Button } from "../../../components/ui/button"
import { ArrowLeft, Loader2 } from "lucide-react"

const VerificationStep = ({ otpFormik, timerStarted = false, email, onVerified, onBack, onResend }) => {
  const otpInputs = useRef([]);
  const [seconds, setSeconds] = useState(0); // 1 minutes = 60 seconds
  const [canResend, setCanResend] = useState(false);
  const length = 6;

  useEffect(() => {
    let timer;
    if (seconds > 0) {
      timer = setTimeout(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      setCanResend(true);
    }
    return () => clearTimeout(timer);
  }, [seconds]);

  useEffect(() => {
    if (timerStarted) {
      setCanResend(false);
      setSeconds(60)
    }
  }, [timerStarted]);

  const handleResend = () => {
    console.log(email, "Email");
    otpFormik.setFieldValue("email", email);
    setCanResend(false);
    setSeconds(60); // reset to 1 minutes
    onResend(); // Trigger resend logic
  };

  const formatTime = (secs) => {
    const m = String(Math.floor(secs / 60)).padStart(2, '0');
    const s = String(secs % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otpFormik.values.otp];
    newOtp[index] = value;
    otpFormik.setFieldValue("otp", newOtp);

    if (index === length - 1 && value !== "") {
      onVerified();
    }

    if (value && index < newOtp.length - 1) {
      otpInputs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text").trim();
    if (!/^\d+$/.test(paste)) return;
    const digits = paste.slice(0, 6).split("");
    const newOtp = [...otpFormik.values.otp];
    digits.forEach((digit, i) => {
      newOtp[i] = digit;
      if (otpInputs.current[i]) {
        otpInputs.current[i].value = digit;
      }
    });
    otpFormik.setFieldValue("otp", newOtp);
    otpInputs.current[digits.length - 1]?.focus();
    if (digits.length === 6) {
      onVerified();
    }
    e.preventDefault();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpFormik.values.otp[index] && index > 0) {
      otpInputs.current[index - 1]?.focus();
    }
  };

  return (
    <div className="space-y-6 w-full max-w-md mx-auto">
      <div className="mb-4">
        <Button
          type="button"
          variant="ghost"
          className="btn btn-link text-decoration-none ps-0"
          onClick={onBack}
        >
          <ArrowLeft className="me-2" size={16} />
          Back
        </Button>
      </div>

      <div className="text-center">
        <h3 className="auth-text-lg">Verify your email</h3>
        <p className="text-sm text-gray-500 mt-2 mb-3">
          We've sent a verification code to {email}
        </p>
      </div>

      <div className="flex flex-col items-center gap-4">
        <div className="d-flex justify-content-between">
          {otpFormik.values.otp.map((digit, index) => (
            <input
              key={index}
              autoFocus={index === 0 ? true : false}
              type="text"
              className="form-control text-center mx-1"
              style={{ width: "40px", height: "40px", fontSize: "20px" }}
              maxLength="1"
              value={digit}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={handlePaste}
              onChange={(e) => handleChange(e.target.value, index)}
              ref={(el) => (otpInputs.current[index] = el)}
            />
          ))}
        </div>

        <div className="d-flex justify-content-center mt-3">
          {canResend ? (
              <Button
                  variant="link"
                  class="btn btn-link d-inline-flex align-items-center justify-content-center gap-2
                  text-primary text-decoration-underline text-nowrap rounded px-4 py-2 fw-medium small"
                  onClick={handleResend}>
                Didn't receive the code? Resend
              </Button>
          ) : (
              <p className="text-gray-500">Resend OTP available in {formatTime(seconds)}</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default VerificationStep
